import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SynagogueIcon(props: IconProps) {
    return <Icon {...props} iconKey={"synagogue"}/>
}
